import React from 'react';
import { PartyJournalIcon } from '../primitives/icons';
import { CalmToolRow } from './CalmToolRow';
import { getEffectiveCampaignFeatures } from '../../../../campaignFeatureAccess';

export const CalmTools = ({
  palette,
  bodyFont,
  c,
  density,
  campaign,
  onOpenPartyJournal,
  onOpenWorldLore,
  onOpenCampaignModule,
}) => {
  const features = campaign?.effectiveFeatures || getEffectiveCampaignFeatures(campaign?.enabledFeatures || null);
  const isDm = campaign?.role === 'owner' || campaign?.role === 'dm';
  const tools = [
    {
      key: 'journal',
      label: 'Party Journal',
      sub: 'past sessions and notes',
      icon: <PartyJournalIcon size={36} />,
      onClick: onOpenPartyJournal,
    },
    {
      key: 'world-lore',
      label: 'World Lore / Atlas',
      sub: 'revealed lore and places',
      icon: <PartyJournalIcon size={36} />,
      onClick: onOpenWorldLore,
    },
    features.travelLog && {
      key: 'travel',
      label: 'Travel Log',
      sub: 'days, meals, and travel history',
      icon: '📜',
      onClick: () => onOpenCampaignModule?.('travel'),
    },
    features.combat && {
      key: 'combat',
      label: 'Combat',
      sub: 'turns, health bars, spells, and abilities',
      icon: '⚔',
      onClick: () => onOpenCampaignModule?.('combat'),
    },
    features.shops && {
      key: 'shops',
      label: 'Shops',
      sub: 'merchants and campaign wallets',
      icon: '🏪',
      onClick: () => onOpenCampaignModule?.('shop'),
    },
    features.loot && {
      key: 'loot',
      label: 'Loot',
      sub: 'encounter drops and awards',
      icon: '⚜',
      onClick: () => onOpenCampaignModule?.('loot'),
    },
    features.crafting && {
      key: 'crafting',
      label: 'Crafting',
      sub: features.professions ? 'recipes, materials, and professions' : 'recipes and materials',
      icon: '⚒',
      onClick: () => onOpenCampaignModule?.('crafting'),
    },
    isDm && features.systems && {
      key: 'systems',
      label: 'Systems',
      sub: 'custom campaign mechanics',
      icon: '🔮',
      onClick: () => onOpenCampaignModule?.('dm'),
    },
  ].filter(Boolean);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {tools.map(tool => (
        <CalmToolRow
          key={tool.key} tool={tool}
          palette={palette}
          bodyFont={bodyFont}
          c={c}
        />
      ))}
    </div>
  );
};
